<script setup lang="ts">
import { Enums } from "@/enums";
import { computed } from "vue";
import { assertUnhandledStatus } from "../../common/asserts.common";

const props = defineProps<{
    status: Enums.InvoiceStatusEnum.Values;
}>();

const label = computed(() => Enums.InvoiceStatusEnum.label(props.status));
const color = computed(() => {
    switch (props.status) {
        case "U":
            return "bg-blue-500";
        case "P":
            return "bg-green-500";
        case "C":
            return "bg-red-500";
        case "W":
            return "bg-purple-500";
        default:
            return assertUnhandledStatus(props.status);
    }
});
</script>

<template>
    <div v-if="props.status === 'W'" class="rns-g-badge" :class="color">Lunas</div>
    <div v-else class="rns-g-badge" :class="color">{{ label }}</div>
</template>

<style>
@reference "@/styles/main.css";
</style>
